import React from "react";

export enum NavHeaderTypeEnum {
  Overview = "overview",
  Customers = "customers",
  Setup = "setup",
}

export interface NavSectionInterface {
  type: NavHeaderTypeEnum;
  collapsedSidebar?: boolean;
}

export interface NavHeaderInterface extends NavSectionInterface {}

export interface NavItemInterface {
  to: string;
  name: string;
  icon: React.JSX.Element;
}

export interface navigationInterface {
  [key: string]: {
    links: NavItemInterface[];
  };
}
